/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerReprocessOlafReprocessMutationRequest, TriggerReprocessOlafReprocessMutationResponse } from "../models/TriggerReprocessOlafReprocess";

export function getTriggerReprocessOlafReprocessUrl() {
  const res = { method: 'POST', url: `/olaf/reprocess` as const }
  return res
}

/**
 * @summary Trigger standalone OLAF reprocess
 * {@link /olaf/reprocess}
 */
export async function triggerReprocessOlafReprocess(data: TriggerReprocessOlafReprocessMutationRequest, config: Partial<RequestConfig<TriggerReprocessOlafReprocessMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<TriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<Error>, TriggerReprocessOlafReprocessMutationRequest>({ method : "POST", url : getTriggerReprocessOlafReprocessUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}